import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_FAQ_START, PUT_FAQ_ERROR, PUT_FAQ_START, PUT_FAQ_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/faqs/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_FAQ_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_FAQ_ERROR, error });
  } finally {
    yield put({ type: GET_FAQ_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* put_faqs() {
  yield takeLatest(PUT_FAQ_START, edit);
}
